export class ListEffectiveTagsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resource",
            "baseName": "resource",
            "type": "DataCatalogTagResourceRef",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListEffectiveTagsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
